// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1XAWk","vLegacy":"SelectSecondary_vLegacy__2rrUz","error":"SelectSecondary_error__pf7OA","disabled":"SelectSecondary_disabled__2SrOw"};